export default __webpack_public_path__ + "static/media/projects_heat.8db3ea5a.geojson";